import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import { actions } from '../actions';
import { actions as mapActions } from 'mapVisualizer';
import { getControlId, getMapErrors, getMapInstanceSettings, getData, getGradientMapLookup, getGradientMapSourceType, getApiPollingTimeInterval } from '../selectors';
import { MapDataApi } from '../requests';
import { network } from '@imodules/helix';
import { getEChartsRef } from 'shared/echartsRef';
import { getHighlights } from './highlight';

const { populateMapData } = mapActions;

export const initiateMapPolling = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const timeInterval: number = getApiPollingTimeInterval(state) || 0;

        while (getMapErrors(state) < 5) {
            const request = dispatch(pollMap());
            try {
                await request;
            } catch (error: any) {
                dispatch(actions.apiCallFailure(error.message));
            }
            await new Promise(resolve => setTimeout(resolve, timeInterval));
        }
    };
};

export const pollMap = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const settings = getMapInstanceSettings(state);
        const controlId = getControlId(state);
        if (settings) {
            try {
                dispatch(await makeMapRequest(controlId));
                dispatch(actions.apiCallSuccess());
            } catch (error: any) {
                dispatch(actions.apiCallFailure(error.message));
            }
        }
    };
};

export const makeMapRequest = (controlId: number): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        try {
            const request = MapDataApi.createGetRequest(controlId);
            const result: any = await network.call(request);

            if (result.error) {
                dispatch(actions.apiCallFailure(result.error.message));
            } else {
                const echartsRef = await getEChartsRef(controlId);
                let highlights: any = [];
                if (echartsRef) {
                    const state = getState();
                    const oldValues: any = getData(state);
                    const gradientDataLookup: { [K: string]: string } = getGradientMapLookup(state);
                    const mapDataSource = getGradientMapSourceType(state);
                    highlights = await getHighlights(result.response.content, echartsRef, oldValues, gradientDataLookup, mapDataSource);
                }
                dispatch(populateMapData(result.response.content));
                dispatch(actions.apiCallSuccess());
                await new Promise(resolve => setTimeout(resolve, 100));
                for (const h of highlights) {
                    await h;
                }
            }
        } catch (error: any) {
            dispatch(actions.apiCallFailure(error.message));
        }
    };
};
export const watchGetMapData = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return (dispatch) => {
        dispatch(initiateMapPolling());
    };
};